import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { softwareListCustomEmbedRoute } from '@atlassian/jira-router-routes-software-list-routes/src/softwareListCustomEmbedRoute.tsx';
import { ListEmbedSkeleton } from '@atlassian/jira-skeletons/src/ui/list/ListSkeleton.tsx';
import { listEmbedEntryPoint } from '@atlassian/jira-spa-apps-jsw-list-embed/entrypoint.tsx';
import { EmbedIssueNavigatorSkeleton } from '@atlassian/jira-skeletons/src/ui/issue-navigator/components/embed-app.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getCommonProjectResources } from '@atlassian/jira-router-routes-issue-navigator-entries/src/common/getCommonProjectResources.tsx';
import { notFoundPageEntrypoint } from '@atlassian/jira-router-routes-not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { issueNavigatorEmbedPageEntryPoint } from '@atlassian/jira-router-routes-issue-navigator-entries/src/ui/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getListProjectResources } from './common/getListProjectResources.tsx';

const listEmbedPageEntrypoint = createChromelessEntryPoint({
	main: listEmbedEntryPoint,
});

export const softwareListCustomEmbedRouteEntry = createEntry(softwareListCustomEmbedRoute, () => ({
	group: 'software',
	skeleton: fg('jira_list_nin_merge') ? EmbedIssueNavigatorSkeleton : ListEmbedSkeleton,
	entryPoint() {
		if (fg('jira_list_nin_merge')) {
			return fg('jira_nin_smart_link') ? issueNavigatorEmbedPageEntryPoint : notFoundPageEntrypoint;
		}
		return listEmbedPageEntrypoint;
	},
	layout: chromelessLayout,
	resources: fg('jira_list_nin_merge')
		? [...getCommonProjectResources(), getConsolidationStateResource()]
		: [...getNavigationResources(), ...getListProjectResources()],
	ufoName: 'next-gen-list-embed',
}));
